/* Hathaspace — mobile behaviors, loaded on every page (theme.liquid).
   1. Hamburger → slide-in nav ([data-menu-open] / [data-menu-close] / [data-mnav]).
   2. Turns every .hts-cards row into a carousel with pagination dots (.hts-dots).
      The dots are built on all viewports but only shown ≤767px (see hts-mobile.css);
      the scroll math is inert on desktop where the row is a static grid. */
(function () {
  "use strict";

  /* ---------- slide-in mobile menu ---------- */
  function nav() { return document.querySelector("[data-mnav]"); }
  function openNav() {
    var m = nav(); if (!m) return;
    m.classList.add("is-open"); m.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }
  function closeNav() {
    var m = nav(); if (!m) return;
    m.classList.remove("is-open"); m.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-menu-open]")) { e.preventDefault(); openNav(); return; }
    if (e.target.closest("[data-menu-close]")) { e.preventDefault(); closeNav(); return; }
    if (e.target.closest("[data-mnav] a")) { closeNav(); }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeNav(); });
  // Crossing back to desktop: make sure the menu isn't left open / body left locked.
  var wide = window.matchMedia("(min-width: 768px)");
  var onWide = function (e) { if (e.matches) closeNav(); };
  if (wide.addEventListener) wide.addEventListener("change", onWide);
  else if (wide.addListener) wide.addListener(onWide);

  /* ---------- carousel dots ---------- */
  function cardsOf(track) {
    return Array.prototype.slice.call(track.children).filter(function (c) {
      return !c.classList.contains("hts-dots");
    });
  }
  function enhance(track) {
    if (track.__htsDots) return;
    var items = cardsOf(track);
    if (items.length < 2) return;

    var dots = document.createElement("div");
    dots.className = "hts-dots";
    items.forEach(function (_, i) {
      var b = document.createElement("button");
      b.type = "button";
      b.setAttribute("aria-label", "Go to item " + (i + 1));
      b.addEventListener("click", function () {
        items[i].scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
      });
      dots.appendChild(b);
    });
    track.parentNode.insertBefore(dots, track.nextSibling);
    track.__htsDots = dots;

    function update() {
      var tr = track.getBoundingClientRect(), center = tr.left + tr.width / 2;
      var best = 0, bestD = Infinity;
      items.forEach(function (c, i) {
        var r = c.getBoundingClientRect(), cc = r.left + r.width / 2, d = Math.abs(cc - center);
        if (d < bestD) { bestD = d; best = i; }
      });
      Array.prototype.forEach.call(dots.children, function (d, i) {
        if (i === best) d.setAttribute("aria-current", "true");
        else d.removeAttribute("aria-current");
      });
    }
    var raf;
    track.addEventListener("scroll", function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener("resize", update);
    update();
  }
  function initCarousels() {
    document.querySelectorAll(".hts-cards").forEach(enhance);
  }

  function init() { initCarousels(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
